<template>
<div class="contents">
  <div class="search-box">
    <div class="ilblk">
      <div>登録日</div>
      <div>
        <my-calendar
          v-model="search.registerDtFrom"
          width="75px"
        ></my-calendar>
        <span class="cal-tilda">〜</span>
        <my-calendar
          v-model="search.registerDtTo"
          width="75px"
        ></my-calendar>
      </div>
    </div>
    <div class="ilblk">
      <div>ユーザーID</div>
      <div>
        <input type="text" v-model="search.userId" class="form-control">
      </div>
    </div>
    <div class="ilblk">
      <div>名前</div>
      <div>
        <input type="text" v-model="search.name" class="form-control">
      </div>
    </div>
    <div class="ilblk">
      <div>カナ</div>
      <div>
        <input type="text" v-model="search.kana" class="form-control">
      </div>
    </div>
    <div class="ilblk" style="width:100px;">
      <div>郵便番号</div>
      <div>
        <input type="text" v-model="search.billAddrZipcode" class="form-control">
      </div>
    </div>
    <div class="ilblk" style="width:110px;">
      <div>電話番号</div>
      <div>
        <input type="text" v-model="search.phoneNumber" class="form-control">
      </div>
    </div>
    <div class="ilblk">
      <div>メールアドレス①</div>
      <div>
        <input type="text" v-model="search.email" class="form-control">
      </div>
    </div>
    <div class="ilblk">
      <div>利用ステータス</div>
      <div>
        <select v-model="search.status" style="width:100px;">
          <option value="">全て</option>
          <option v-for="elem in lovs.status_type" :value="elem.key">
            {{elem.val}}
          </option>
        </select>
      </div>
    </div>
    <div class="ilblk">
      <button class="btn" @click="searchUsers()">
        <i class="fa fa-search"></i>
        検索
      </button>
    </div>
  </div>

  <div class="list-box">
    <table class="tbl">
      <colgroup>
        <col style="width:60px;">
        <col style="width:40px;">
        <col style="width:80px;">
        <col style="width:40px;">
        <col style="width:40px;">
        <col style="width:130px;">
        <col style="width:120px;">
        <col style="width:80px;">
        <col style="width:50px;">
        <col style="width:150px;">
        <col style="width:40px;">
        <col style="width:90px;">
        <col style="width:90px;">
        <col style="width:40px;">
        <col style="width:40px;">
        <col style="width:60px;">
        <col style="width:60px;">
        <col style="width:60px;">
        <col style="width:60px;">
        <col style="width:60px;">
        <col style="width:40px;">
        <col style="width:40px;">
        <col style="width:100px;">
        <col style="width:40px;">
        <col style="width:40px;">
        <col style="width:50px;">
        <col style="width:40px;">
      </colgroup>
      <div>アクティブユーザー件数:{{this.activeUsers.length}}</div>
      <tr>
        <th>登録日時</th>
        <th>ユーザーID</th>
        <th>名前 (かな)</th>
        <th>洗濯工数</th>
        <th>たたみ工数</th>
        <th>現在プラン (開始日)</th>
        <th>翌月以降プラン (開始日)</th>
        <th>集配方法</th>
        <th>会社/店舗名</th>
        <th>住所1</th>
        <th>電話番号</th>
        <th>メールアドレス①</th>
        <th>メールアドレス②</th>
        <th>決済方法</th>
        <th>運営メモ</th>
        <th>集配リスト</th>
        <th>集配開始</th>
        <th>集配期限</th>
        <th>集荷個数</th>
        <th>作業時間</th>
        <th>土曜集配</th>
        <th>オイル対応</th>
        <th>種別</th>
        <th>洗い方指定</th>
        <th>たたみ方指定</th>
        <th>利用ステータス</th>
        <th>権限</th>
      </tr>
      <tr v-for="(user, idx) in users">
        <td>{{user.created_at | dtFormat('yyyy/mm/dd HH:MM:SS')}}</td>
        <td>{{user.id}}</td>
        <td>
          <span>{{user.name1}} {{user.name2}} ({{user.kana1}} {{user.kana2}})</span>
          <button v-show="isStaffTypeManager" class="btn btn_sm bg_blue fr"
              @click="editCustomerProfile(user)">
            編集
          </button>
        </td>
        <td>
          <div v-show="!user.input_wash_weight">
            <span>{{user.washWeightDisp}}</span>
            <button class="btn btn_sm bg_blue fr"
                @click="switchToInputModeWashWeight(user)">
              更新
            </button>
          </div>
          <div v-show="user.input_wash_weight">
            <div>
              <select v-model="user.input_wash_weight_str" style="width:70px;">
                <option v-for="elem in lovs.wash_weight_point" v-bind:value="elem.key">
                  {{elem.val}}
                </option>
              </select>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                  @click="updateWashWeight(idx, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                  @click="switchToNonInputModeWashWeight(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
        <td>
          <div v-show="!user.input_weight">
            <span>{{user.weightDisp}}</span>
            <button class="btn btn_sm bg_blue fr"
                @click="switchToInputModeWeight(user)">
              更新
            </button>
          </div>
          <div v-show="user.input_weight">
            <div>
              <select v-model="user.input_weight_str" style="width:90px;">
                <option v-for="elem in lovs.weight_point" v-bind:value="elem.key">
                  {{elem.val}}
                </option>
              </select>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                  @click="updateWeight(idx, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                  @click="switchToNonInputModeWeight(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
        <td>
          {{user.planPart1Disp}} ({{user.pStartDisp | dtFormat('yyyy/mm/dd')}}~)
            <button v-show="isStaffTypeManager" @click="changePlan(user)" class="btn btn1 btn_sm bg_blue fr">
              編集
            </button>
        </td>
        <td>{{user.nextMonthPlanPart1Disp}} {{user.nextMonthPStartDisp}}</td>
        <td>{{user.pickupDeliveryTypeDisp}}</td>
        <td>
          <span>{{user.company_name}}</span>
        </td>
        <td style="white-space:normal;">〒{{user.send_addr_zipcode}} {{user.send_addr_detail1}} {{user.send_addr_detail2}} {{user.send_addr_detail3}}</td>
        <td>{{user.phone_number}}</td>
        <td>{{user.email}}</td>
        <td>{{user.email2}}</td>
        <td>{{paymentMethodMap[user.payment_method_id].val}}</td>
        <td>
          <span v-if="user.management_notes">有り</span>
          <span v-else>無し</span>
          <button class="btn btn_sm bg_blue fr"
            @click="openManagementNotesModal(user)">
            編集
          </button>
        </td>
        <td>
          <InlineEditCell
            :is-editing="user.input_is_dispatch_excluded"
            :display-value="dispatchPlanSettingComposable.formatIsDispatchExcludedForDisplay(user.is_dispatch_excluded)"
            :can-edit="dispatchPlanSettingComposable.canEditDispatchPlanSetting()"
            edit-button-label="編集"
            @start-edit="dispatchPlanSettingComposable.switchToInputModeIsDispatchExcluded(user)"
            @confirm="dispatchPlanSettingComposable.updateIsDispatchExcluded(users, idx, user)"
            @cancel="dispatchPlanSettingComposable.switchToNonInputModeIsDispatchExcluded(user)"
          >
            <select
              v-model="user.input_is_dispatch_excluded_val"
              class="dispatch-included-select"
            >
              <option :value="0">あり</option>
              <option :value="1">なし</option>
            </select>
          </InlineEditCell>
        </td>
        <td>
          <div v-show="!user.input_arrival_start_time">
            <span>{{ dispatchPlanSettingComposable.formatTimeForDisplay(user.arrival_start_time) }}</span>
            <button
              v-show="dispatchPlanSettingComposable.canEditDispatchPlanSetting()"
              class="btn btn_sm bg_blue fr"
              @click="dispatchPlanSettingComposable.switchToInputModeArrivalStartTime(user)">
              編集
            </button>
          </div>
          <div v-show="user.input_arrival_start_time">
            <div>
              <select v-model="user.input_arrival_start_time_str" style="width:90px;">
                <option value="">未設定</option>
                <option
                  v-for="elem in dispatchPlanSettingComposable.state.arrivalTimeOptions"
                  :key="elem.val"
                  :value="elem.val">
                  {{ elem.label }}
                </option>
              </select>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                @click="dispatchPlanSettingComposable.updateArrivalStartTime(users, idx, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                @click="dispatchPlanSettingComposable.switchToNonInputModeArrivalStartTime(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
        <td>
          <div v-show="!user.input_arrival_deadline_time">
            <span>{{ dispatchPlanSettingComposable.formatTimeForDisplay(user.arrival_deadline_time) }}</span>
            <button
              v-show="dispatchPlanSettingComposable.canEditDispatchPlanSetting()"
              class="btn btn_sm bg_blue fr"
              @click="dispatchPlanSettingComposable.switchToInputModeArrivalDeadlineTime(user)">
              編集
            </button>
          </div>
          <div v-show="user.input_arrival_deadline_time">
            <div>
              <select v-model="user.input_arrival_deadline_time_str" style="width:90px;">
                <option value="">未設定</option>
                <option
                  v-for="elem in dispatchPlanSettingComposable.state.arrivalTimeOptions"
                  :key="elem.val"
                  :value="elem.val">
                  {{ elem.label }}
                </option>
              </select>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                @click="dispatchPlanSettingComposable.updateArrivalDeadlineTime(users, idx, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                @click="dispatchPlanSettingComposable.switchToNonInputModeArrivalDeadlineTime(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
        <td>
          <div v-show="!user.input_pickup_count">
            <span>{{ user.pickup_count || '' }}</span>
            <button
              v-show="dispatchPlanSettingComposable.canEditDispatchPlanSetting()"
              class="btn btn_sm bg_blue fr"
              @click="dispatchPlanSettingComposable.switchToInputModePickupCount(user)">
              編集
            </button>
          </div>
          <div v-show="user.input_pickup_count">
            <div>
              <select v-model="user.input_pickup_count_str" style="width:90px;">
                <option value="">未設定</option>
                <option
                  v-for="elem in dispatchPlanSettingComposable.state.pickupCountOptions"
                  :key="elem"
                  :value="elem">
                  {{ elem }}
                </option>
              </select>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                @click="dispatchPlanSettingComposable.updatePickupCount(users, idx, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                @click="dispatchPlanSettingComposable.switchToNonInputModePickupCount(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
        <td>
          <div v-show="!user.input_task_duration_minutes">
            <span>{{ dispatchPlanSettingComposable.formatTimeForDisplay(user.task_duration_minutes) }}</span>
            <button
              v-show="dispatchPlanSettingComposable.canEditDispatchPlanSetting()"
              class="btn btn_sm bg_blue fr"
              @click="dispatchPlanSettingComposable.switchToInputModeTaskDurationMinutes(user)">
              編集
            </button>
          </div>
          <div v-show="user.input_task_duration_minutes">
            <div>
              <select v-model="user.input_task_duration_minutes_str" style="width:90px;">
                <option value="">未設定</option>
                <option
                  v-for="elem in dispatchPlanSettingComposable.state.taskDurationMinutesOptions"
                  :key="elem.val"
                  :value="elem.val">
                  {{ elem.label }}
                </option>
              </select>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                @click="dispatchPlanSettingComposable.updateTaskDurationMinutes(users, idx, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                @click="dispatchPlanSettingComposable.switchToNonInputModeTaskDurationMinutes(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
        <td>
          <div v-show="!user.input_sat">
            <span>{{user.satDisp}}</span>
            <button class="btn btn_sm bg_blue fr"
                @click="switchToInputModeSat(user)">
              更新
            </button>
          </div>
          <div v-show="user.input_sat">
            <div>
              <select v-model="user.input_sat_str" style="width:100px;">
                <option value="1">可能</option>
                <option value="0">不可</option>
              </select>
            </div>
            <div v-show="!canChangeSatRequest[user.id]">
              <span class="iferror submit_text">
                ▲ 変更不可
              </span>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                  @click="updateSat(idx, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                  @click="switchToNonInputModeSat(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
        <td>
          <div v-show="oilLaundryInputComposable.shouldShowOilTreatmentDisplay(user.id)">
            <span>{{ getHasOilTreatmentText(user.has_oil_treatment) }}</span>
            <button class="btn btn_sm bg_blue fr"
                @click="oilLaundryInputComposable.enterOilTreatmentInputMode(user)">
              更新
            </button>
          </div>
          <div v-show="oilLaundryInputComposable.shouldShowOilTreatmentEditor(user.id)">
            <div>
              <select v-model="oilLaundryInputComposable.states[user.id].oilTreatmentInput" style="width:100px;">
                <option v-if="!oilLaundryInputComposable.states[user.id].oilTreatmentInput" value="">未設定</option>
                <option value="1">あり</option>
                <option value="0">なし</option>
              </select>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                  @click="oilLaundryInputComposable.persistOilTreatment(users, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                  @click="oilLaundryInputComposable.exitOilTreatmentInputMode(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
        <td>
          <div v-show="oilLaundryInputComposable.shouldShowLaundryTypeDisplay(user.id)">
            <span>{{ getLaundryTypeTextByMap(user.laundry_type, laundryTypeMap) }}</span>
            <button class="btn btn_sm bg_blue fr"
                @click="oilLaundryInputComposable.enterLaundryTypeInputMode(user)">
              更新
            </button>
          </div>
          <div v-show="oilLaundryInputComposable.shouldShowLaundryTypeEditor(user.id)">
            <div>
              <select v-model="oilLaundryInputComposable.states[user.id].laundryTypeInput" class="select-laundry-type">
                <option v-if="!oilLaundryInputComposable.states[user.id].laundryTypeInput" value="">未設定</option>
                <option v-for="(laundryType, key) in laundryTypeMap" :key="key" :value="key">
                  {{ laundryType.val }}
                </option>
              </select>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                  @click="oilLaundryInputComposable.persistLaundryType(users, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                  @click="oilLaundryInputComposable.exitLaundryTypeInputMode(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
        <td>
          <div v-show="!user.input_wash_type">
            <span>{{user.washTypeDisp}}</span>
            <button class="btn btn_sm bg_blue fr"
                @click="switchToInputModeWashType(user)">
              更新
            </button>
          </div>
          <div v-show="user.input_wash_type">
            <div>
              <select v-model="user.input_wash_type_str" style="width:100px;">
                <option value="1">あり</option>
                <option value="0">なし</option>
              </select>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                  @click="updateWashType(idx, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                  @click="switchToNonInputModeWashType(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
        <td>
          <div v-show="!user.input_fold_type">
            <span>{{user.foldTypeDisp}}</span>
            <button class="btn btn_sm bg_blue fr"
                @click="switchToInputModeFoldType(user)">
              更新
            </button>
          </div>
          <div v-show="user.input_fold_type">
            <div>
              <select v-model="user.input_fold_type_str" style="width:100px;">
                <option value="1">あり</option>
                <option value="0">なし</option>
              </select>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                  @click="updateFoldType(idx, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                  @click="switchToNonInputModeFoldType(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
        <td>
          <div v-show="!user.input_status">
            <span>{{statusMap[user.status]}}</span>
            <button v-show="isStaffTypeManager" class="btn btn_sm bg_blue fr"
              @click="switchToInputModeStatus(user)">
              更新
            </button>
            <button v-show="user.is_admin === 0 && isStaffTypeManager" class="btn btn_sm bg_danger fr"
              @click="deleteUser(user.id)">
              削除
            </button>
          </div>
          <div v-show="user.input_status">
            <div>
              <select v-model="user.input_status_str" style="width:100px;">
                <option v-for="elem in statusMapEdit" v-bind:value="elem.key">
                  {{elem.val}}
                </option>
              </select>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                  @click="updateStatus(idx, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                  @click="switchToNonInputModeStatus(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
        <td>
          <div v-show="!user.input_role">
            <span>{{user.roleDisp}}</span>
            <button v-show="isStaffTypeManager" class="btn btn_sm bg_blue fr"
                @click="switchToInputModeRole(user)">
              更新
            </button>
          </div>
          <div v-show="user.input_role">
            <div>
              <select v-model="user.input_role_str" style="width:100px;">
                <option v-for="elem in filterRole" v-bind:value="elem.key">
                  {{elem.val}}
                </option>
              </select>
            </div>
            <div style="margin:4px 0 0 0;">
              <button class="btn btn_sm bg_danger"
                  @click="updateRole(idx, user)">
                確定
              </button>
              <button class="btn btn_sm bg_blue"
                  @click="switchToNonInputModeRole(user)">
                キャンセル
              </button>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>

  <modal
    val="userInfo"
    v-if="showManagementNotesModal"
    title="運営メモ"
    bottomCloseButtonLabel="更新"
    @close="updateManagementNotes()"
    @dismiss="showManagementNotesModal = false">
    <div slot="body">
      <p><textarea type="text" class="form_basic" v-model="userInfo.management_notes"></textarea></p>
      <div class="err-msg-area">
        <p><span class="font_orange" v-for="e in serverErrors">
          {{e}}
        </span></p>
      </div>
    </div>
  </modal>

</div>
</template>

<script>
import { AdminPageType } from '@/consts/admin'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { useAdminPageAccess } from '@/composables/useAdminPageAccess'
import adminUserApi from '@/api/adminUser'
import {
  getLaundryTypeTextByMap,
  getHasOilTreatmentText,
} from '@/utils/oilAndLaundryTypeUtils'
import { isOnetimePlan } from '@/utils/planUtils'
import { useOilLaundryInput } from '@/composables/useOilLaundryInput'
import { useDispatchPlanSetting } from '@/composables/useDispatchPlanSetting'
import InlineEditCell from '@/components/Admin/InlineEditCell.vue'

export default {
  components: {
    InlineEditCell,
  },
  name: 'admin-onetime-users',
  props: {
    searchPrm: {
      type: Object,
      'default': () => ({
        registerDtFrom: '',
        registerDtTo: '',
        userId: '',
        name: '',
        kana: '',
        billAddrZipcode: '',
        phoneNumber: '',
        email: '',
        status: '',
      })
    },
    adminType: {
      type: String,
      default: AdminPageType.ADMIN
    }
  },
  data() {
    const oilLaundryInputComposable = useOilLaundryInput()
    const dispatchPlanSettingComposable = useDispatchPlanSetting()
    return {
      search: {
        registerDtFrom: '',
        registerDtTo: '',
        userId: '',
        name: '',
        kana: '',
        billAddrZipcode: '',
        phoneNumber: '',
        email: '',
        status: '',
      },

      lovs: {},
      planMap: {},
      pdTypeMap: {},
      statusMap: {},
      statusMapEdit: {},
      roleMap: {},
      washWeightPointMap: {},
      weightPointMap: {},
      optionMap: {},
      paymentMethodMap: {},
      laundryTypeMap: {},
      users: [],
      activeUsers: [],
      canChangeSatRequest: [],
      oilLaundryInputComposable,
      dispatchPlanSettingComposable,

      showManagementNotesModal: false,
      userInfo: {},

      serverErrors: [],
    }
  },
  async mounted() {
    const { ensureLeaderAccess, ensureManagerAccessInMaintenance } = useAdminPageAccess(this.adminType)
    const canAccess = await ensureLeaderAccess()
    if (!canAccess) return
    if (!await ensureManagerAccessInMaintenance()) return

    this.dispatchPlanSettingComposable.initializeDispatchPlanOptions()

    const mst = await window.master.$promise
    this.lovs = mst.lovs
    this.planMap = mst.planMap
    this.pdTypeMap = mst.lovsMap.pd_type
    this.roleMap = mst.lovsMap.role
    this.washWeightPointMap = mst.lovsMap.wash_weight_point
    this.weightPointMap = mst.lovsMap.weight_point
    this.optionMap = mst.lovsMap.user_plan_option
    this.paymentMethodMap = mst.lovsMap.payment_method
    this.laundryTypeMap = mst.lovsMap.laundry_type

    this.setSearchPrm()

    const statusMap = {}
    const statusMapEdit = []
    this.lovs.status_type.forEach(e => {
      statusMap[parseInt(e.key)] = e.val
      if (e.key != 0) {
        statusMapEdit.push(e)
      }
    })
    this.statusMap = statusMap
    this.statusMapEdit = statusMapEdit

    this.searchUsers()
  },
  computed: {
    ...mapGetters('user', ['isStaffTypeManager']),
    filterRole() {
      return this.lovs.role.filter(e => e.key != 200)
    }
  },
  methods: {
    getLaundryTypeTextByMap,
    getHasOilTreatmentText,
    convUser(user) {
      const ret = Object.assign({}, user)

      this.canChangeSatRequest[user.id] = true
      ret.receiptDisp = this.convReceipt(user.receipt)
      ret.satDisp = this.convSat(user.is_saturday_available)
      ret.washTypeDisp = this.convWashType(user.wash_type_setting)
      ret.foldTypeDisp = this.convFoldType(user.fold_type_setting)
      ret.roleDisp = this.convRole(user.role)
      ret.washWeightDisp = this.convWashWeight(user.wash_weight)
      ret.weightDisp = this.convWeight(user.weight)
      ret.planPart1Disp = this.convPlanPart1(user.plan_id, user.user_plan_option)
      ret.nextMonthPlanPart1Disp = this.convPlanPart1(user.next_month_plan_id, user.next_month_user_plan_option)

      // 現在プランの開始日を月初に変更
      let pStartDisp = new Date(user.valid_from)
      if (user.is_first_plan === 1) {
        pStartDisp.setDate(1)
      }

      ret.pStartDisp = pStartDisp

      if (user.next_month_plan_valid_from) {
        // 翌月からプランが変わる場合
        const dtFormat = Vue.filter('dtFormat')
        const nextMonthPStartDisp = new Date(user.next_month_plan_valid_from)
        ret.nextMonthPStartDisp = '(' + dtFormat(nextMonthPStartDisp, 'yyyy/mm/dd') + '~)'
      }
      else {
        // 翌月もプランが変わらない場合
        ret.nextMonthPStartDisp = '同左'
      }

      ret.pickupDeliveryTypeDisp = this.convPickupDeliveryType(user.pickup_delivery_type)

      ret['input_available_request_count'] = false
      ret['input_available_request_count_str'] = null
      ret['input_receipt'] = false
      ret['input_receipt_str'] = null
      ret['input_sat'] = false
      ret['input_sat_str'] = null
      ret['input_wash_type'] = false
      ret['input_wash_type_str'] = null
      ret['input_fold_type'] = false
      ret['input_fold_type_str'] = null
      ret['input_status'] = false
      ret['input_status_str'] = null
      ret['input_role'] = false
      ret['input_role_str'] = null
      ret['input_wash_weight'] = false
      ret['input_wash_weight_str'] = null
      ret['input_weight'] = false
      ret['input_weight_str'] = null
      ret['decreaseFlg'] = 0

      this.oilLaundryInputComposable.initializeOilLaundryInputState(ret)
      this.dispatchPlanSettingComposable.initializeDispatchPlanInputState(ret)

      return ret
    },
    convReceipt(receipt) {
      let obj = ''
      if (receipt == 1) {
        obj = 'あり'
      } else {
        obj = 'なし'
      }
      return obj
    },
    convSat(isSaturdayAvailable) {
      let obj = ''
      if (isSaturdayAvailable == 1) {
        obj = '可能'
      } else {
        obj = '不可'
      }
      return obj
    },
    convWashType(wash_type) {
      let obj = ''
      if (wash_type == 1) {
        obj = 'あり'
      } else {
        obj = 'なし'
      }
      return obj
    },
    convFoldType(fold_type) {
      let obj = ''
      if (fold_type == 1) {
        obj = 'あり'
      } else {
        obj = 'なし'
      }
      return obj
    },
    convStatus(status) {
      const obj = this.statusMap[status] || {}
      return obj.val
    },
    convRole(role) {
      const obj = this.roleMap[role] || {}
      return obj.val
    },
    convWashWeight(washWeight) {
      const dispObj = this.washWeightPointMap[washWeight] || {}
      return dispObj.val
    },
    convWeight(weight) {
      const dispObj = this.weightPointMap[weight] || {}
      return dispObj.val
    },
    convPlanPart1(planId, option) {
      let planPart1Disp = ''
      const plan = this.planMap[planId]
      if (plan) { planPart1Disp = plan.name + this.optionDisp(option) }
      return planPart1Disp
    },
    optionDisp(option) {
      const obj = this.optionMap[option]
      return obj ? '/' + obj.val : ''
    },
    convPickupDeliveryType(pickupDeliveryType) {
      const obj = this.pdTypeMap[pickupDeliveryType] || {}
      return obj.val
    },
    filterBySearchParams(user) {
      const search = this.search
      if (search.registerDtFrom) {
        const dtStrConv = search.registerDtFrom.replace(/\//g, '-')
        const dt = new Date(`${dtStrConv}T00:00:00`)
        const createdAt = new Date(user.created_at.replace(' ', 'T'))
        if (dt > createdAt) { return false }
      }
      if (search.registerDtTo) {
        const dtStrConv = search.registerDtTo.replace(/\//g, '-')
        const dt = new Date(`${dtStrConv}T23:59:59`)
        const createdAt = new Date(user.created_at.replace(' ', 'T'))
        if (createdAt > dt) { return false }
      }
      if (search.userId) {
        if (user.id.toString() !== search.userId) { return false }
      }
      if (search.name) {
        const nameStr = `${user.name1} ${user.name2}`
        const reg = new RegExp(search.name)
        if (!nameStr.match(reg)) { return false }
      }
      if (search.kana) {
        const kanaStr = `${user.kana1} ${user.kana2}`
        const reg = new RegExp(search.kana)
        if (!kanaStr.match(reg)) { return false }
      }
      if (search.billAddrZipcode) {
        const zcStr = user.bill_addr_zipcode.replace(/-/g, '')
        const reg = new RegExp(search.billAddrZipcode.replace(/-/g, ''))
        if (!zcStr.match(reg)) { return false }
      }
      if (search.phoneNumber) {
        const pnStr = user.phone_number.replace(/-/g, '')
        const reg = new RegExp(search.phoneNumber.replace(/-/, ''))
        if (!pnStr.match(reg)) { return false }
      }
      if (search.email) {
        const reg = new RegExp(search.email)
        if (!user.email.match(reg)) { return false }
      }
      if (search.status) {
        if (user.status !== parseInt(search.status)) { return false }
      }

      return true
    },
    searchUsers() {
      adminUserApi.index().then(({ data }) => {
        this.users = data
          .map(e => this.convUser(e))
          .filter(e => e.role !== 200)
          .filter(e => isOnetimePlan(e.plan_id))
          .filter(e => this.filterBySearchParams(e))
        this.activeUsers = this.users.filter(e =>
        e.status === 1 && e.role === 900)
      })
    },
    setSearchPrm() {
      this.search = this.searchPrm
    },
    switchToInputMode(user, flg) {
      user.input_available_request_count = true
      user.input_available_request_count_str = user.available_request_count
      user.decreaseFlg = flg
    },
    switchToNonInputMode(user) {
      user.input_available_request_count = false
      user.input_available_request_count_str = null
    },
    openManagementNotesModal(user) {
      this.userInfo = user
      this.showManagementNotesModal = true
    },
    updateManagementNotes() {
      this.serverErrors = []

      const obj = {
        ['management_notes']: this.userInfo.management_notes
      }
      adminUserApi.updateManagementNotes(this.userInfo.id, obj).then(() => {
        this.userInfo = {}
        this.showManagementNotesModal = false
      }).catch(e => {
        const errRes = e.response.data.errors;
        let serverErrors = []
        Object.keys(errRes).forEach(k => {
          serverErrors = serverErrors.concat(errRes[k])
        })
        this.serverErrors = serverErrors;
      })
    },
    deleteUser(userId) {
      let name = 'admin-users-delete'
      if (this.adminType === AdminPageType.STAFF) {
        name = 'staff-users-delete'
      }
      this.$router.push({
        name: name,
        params: {
          id: userId
        }
      })
    },
    switchToInputModeSat(user) {
      user.input_sat = true
      user.input_sat_str = user.is_saturday_available
    },
    switchToNonInputModeSat(user) {
      user.input_sat = false
      user.input_sat_str = null
      this.canChangeSatRequest[user.id] = true
    },
    switchToInputModeWashType(user) {
      user.input_wash_type = true
      user.input_wash_type_str = user.wash_type_setting
    },
    switchToNonInputModeWashType(user) {
      user.input_wash_type = false
      user.input_wash_type_str = null
    },
    switchToInputModeFoldType(user) {
      user.input_fold_type = true
      user.input_fold_type_str = user.fold_type_setting
    },
    switchToNonInputModeFoldType(user) {
      user.input_fold_type = false
      user.input_fold_type_str = null
    },
    switchToInputModeStatus(user) {
      user.input_status = true
      user.input_status_str = user.status
    },
    switchToNonInputModeStatus(user) {
      user.input_status = false
      user.input_status_str = null
    },
    switchToInputModeRole(user) {
      user.input_role = true
      user.input_role_str = user.role
    },
    switchToNonInputModeRole(user) {
      user.input_role = false
      user.input_role_str = null
    },
    switchToInputModeWashWeight(user) {
      user.input_wash_weight = true
      user.input_wash_weight_str = user.wash_weight
    },
    switchToNonInputModeWashWeight(user) {
      user.input_wash_weight = false
      user.input_wash_weight_str = null
    },
    switchToInputModeWeight(user) {
      user.input_weight = true
      user.input_weight_str = user.weight
    },
    switchToNonInputModeWeight(user) {
      user.input_weight = false
      user.input_weight_str = null
    },
    updateSat(idx, user) {
      const obj = {
        ['is_saturday_available']: user.input_sat_str
      }
      adminUserApi.updateSat(user.id, obj).then(() => {
        user.is_saturday_available = user.input_sat_str
        user.satDisp = this.convSat(user.is_saturday_available)
        Vue.set(this.users, idx, user)
        this.switchToNonInputModeSat(user)
      }).catch(err => {
        if (err.response.data.reason === 'have_data') {
          this.canChangeSatRequest[user.id] = false
          user.input_sat = true
          Vue.set(this.users, idx, user)
        }
      })
    },
    updateWashType(idx, user) {
      const obj = {
        ['wash_type_setting']: user.input_wash_type_str
      }
      adminUserApi.updateWashType(user.id, obj).then(() => {
        user.wash_type_setting = user.input_wash_type_str
        user.washTypeDisp = this.convWashType(user.wash_type_setting)
        Vue.set(this.users, idx, user)
        this.switchToNonInputModeWashType(user)
      })
    },
    updateFoldType(idx, user) {
      const obj = {
        ['fold_type_setting']: user.input_fold_type_str
      }
      adminUserApi.updateFoldType(user.id, obj).then(() => {
        user.fold_type_setting = user.input_fold_type_str
        user.foldTypeDisp = this.convFoldType(user.fold_type_setting)
        Vue.set(this.users, idx, user)
        this.switchToNonInputModeFoldType(user)
      })
    },
    updateStatus(idx, user) {
      //退会済からのステータス変更は不可
      if (user.status == 90) {
        alert('すでに退会済のユーザーは他のステータスに変更できません')
        return
      }
      //同じステータスには変更できない
      if (user.status == user.input_status_str) {
        alert('ステータスが変更されていません')
        return
      }

      let isStopped = 0
      //月額クレジット決済の場合
      if (user.latest_payment_method_id == 1) {
        // 継続決済失敗で一時停止中のユーザー
        if (user.user_id) {
          isStopped = 1
          if (user.input_status_str == 1) {
            alert('課金エラーが発生しているためステータスの変更ができません')
            return
          } else if (user.input_status_str == 2) {
            //ここには入らない想定
          } else if (user.input_status_str == 90) {
            if (!confirm('継続課金を無効にします')) {
              return
            }
          }
        } else {
          if (user.input_status_str == 1) {
            if (!confirm('継続課金を再開します')) {
              return
            }
          } else if (user.input_status_str == 2) {
            if (!confirm('継続課金を停止します')) {
              return
            }
          } else if (user.input_status_str == 90) {
            if (!confirm('継続課金を無効にします')) {
              return
            }
          }
        }
      //請求書決済、単発の場合
      } else {
        //なにもしない
      }

      const obj = {
        ['status']: user.input_status_str,
        ['payment_method_id']: user.latest_payment_method_id,
        ['is_stopped']: isStopped
      }
      adminUserApi.updateStatus(user.id, obj).then(() => {
        user.status = user.input_status_str
        user.statusDisp = this.convStatus(user.status)
        Vue.set(this.users, idx, user)
        this.switchToNonInputModeStatus(user)
      })
    },
    updateRole(idx, user) {
      const obj = {
        ['role']: user.input_role_str
      }
      adminUserApi.updateRole(user.id, obj).then(() => {
        user.role = user.input_role_str
        user.roleDisp = this.convRole(user.role)
        Vue.set(this.users, idx, user)
        this.switchToNonInputModeRole(user)
      })
    },
    updateWashWeight(idx, user) {
      const obj = {
        ['wash_weight']: user.input_wash_weight_str
      }
      adminUserApi.updateWashWeight(user.id, obj).then(() => {
        user.wash_weight = user.input_wash_weight_str
        user.washWeightDisp = this.convWashWeight(user.wash_weight)
        Vue.set(this.users, idx, user)
        this.switchToNonInputModeWashWeight(user)
      })
    },
    updateWeight(idx, user) {
      const obj = {
        ['weight']: user.input_weight_str
      }
      adminUserApi.updateWeight(user.id, obj).then(() => {
        user.weight = user.input_weight_str
        user.weightDisp = this.convWeight(user.weight)
        Vue.set(this.users, idx, user)
        this.switchToNonInputModeWeight(user)
      })
    },
    changePlan(user) {
      let name = 'admin-plan-edit'
      if (this.adminType === AdminPageType.STAFF) {
        name = 'staff-plan-edit'
      }
      this.$router.push({
        name: name,
        params: {
          id: user.id,
          searchPrm: this.search,
        }
      })
    },
    editCustomerProfile(user) {
      const name = this.adminType === AdminPageType.STAFF ? 'staff-customer-profile-edit' : 'admin-customer-profile-edit'
      this.$router.push({
        name,
        params: { id: user.id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contents {
  width: 95%;
  margin: 20px auto 0;
  overflow-y: scroll;
  min-height: 400px;
}
.ilblk {
  display: inline-block;
}
.form-control {
  height: 24px;
  font-size: 12px;
  width: 96%;
}
.form-control-sm {
  font-size: 12px;
}
.btn {
  font-size: 16px;
  border-radius: 4px;
  background-color: #00a9ca;
  color: #ffffff;
  padding: 6px 12px;
  cursor: pointer;
}
.btn_yellow {
  background-color: #fc9d07;
  margin-left: 0.8rem;
}
.btn_sm {
  font-size: 12px;
  padding: 2px 6px;
}
.btn.bg_white {
  color: #555555;
  background-color: #ffffff;
  border: 1px solid #aaaaaa;
}
.btn.bg_danger {
  background-color: #d80a0a;
}
.fr {
  float: right;
}

td {
  white-space: normal;
}

.search-box {
  width: 1700px;
}
.list-box {
  margin: 20px 0 0 0;

  .tbl {
    table-layout: fixed;
    font-size: 14px;
    white-space: nowrap;
    width: 4700px;
    border-collapse: collapse;
  }
  th, td {
    border: 1px solid #aaa;
    padding: 2px 4px;
  }
}
.select-laundry-type {
  width: 200px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.dispatch-included-select {
  width: 70px;
}
</style>
